import React from "react";
import { Calculation } from "../../../../../../src/application/Contracts";
import BaseTechTable from "./BaseTechTable";

export default class AquaPlateTable extends BaseTechTable<Calculation.AquaPlateTechnicalData[]> {
    enabledIndirectDirectButton = false;
    getItems = () => {
        return Object.values(this.props.items).sort(
            (a, b) => {
                if (a.dimensions > b.dimensions) {
                    return 1;
                } else if (a.dimensions < b.dimensions) {
                    return -1;
                } else {
                    if (Number.parseFloat(a.primaryFlowRate) < Number.parseFloat(b.primaryFlowRate)) {
                        return -1;
                    } else if (Number.parseFloat(a.primaryFlowRate) > Number.parseFloat(b.primaryFlowRate)) {
                        return 1;
                    } else {
                        return 0;
                    }
                }
            }
        );
    }
    getCurrency = (): string => {
        return this.getItems()[0]?.currency || "";
    }

    getTable() {
        let lastDimensions: string | null = null;
        return <table>
            <thead>
                <tr>
                    <th colSpan={2}>{__("Primary")}</th>
                    <th colSpan={2}>{__("Primary 80°C Secondary 10-60°C")}</th>
                    <th colSpan={2}>{__("Primary 70°C Secondary 10-60°C")}</th>
                    <th rowSpan={2}>{__("Dimensions")}</th>
                    <th rowSpan={2}>{__("Weight (kg)")}</th>
                    <th rowSpan={2}>{__("Part number")}</th>
                    <th rowSpan={2}>{__("Public price" + " " + this.getCurrency())}</th>
                </tr>
                <tr>
                    <th>{__("flow rate (m3/h)")}</th>
                    <th>{__("pres.drop (kPa)")}</th>
                    <th>{__("capacity (kW)")}</th>
                    <th>{__("flow rate (l/s)")}</th>
                    <th>{__("capacity (kW)")}</th>
                    <th>{__("flow rate (l/s)")}</th>
                </tr>
            </thead>
            <tbody>
                {this.getItems().map(item => {
                    let rowClassName = '';
                    if (lastDimensions !== null && lastDimensions !== item.dimensions) {
                        rowClassName = 'border-top';
                    }
                    lastDimensions = item.dimensions;
                    return <tr className={rowClassName} key={item.partnumber}>
                        <td>{item.primaryFlowRate}</td>
                        <td>{item.primaryPressureDrop}</td>
                        <td>{item.primary80.capacity}</td>
                        <td>{item.primary80.flowRate}</td>
                        <td>{item.primary70.capacity}</td>
                        <td>{item.primary70.flowRate}</td>
                        <td>{item.dimensions}</td>
                        <td>{item.weight}</td>
                        <td>{item.partnumber}</td>
                        <td>{item.price}</td>
                    </tr>
                })}
            </tbody>
        </table>
    }
}